import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import PaymentInformation from './payment-information-model'
import {
  CreatePaymentInformationAsync,
  DeletePaymentInformationAsync,
  LoadPaymentInformationsAsync,
} from './paymentInformation-thunk'
const initialState: paymentInformationSliceState = {
  paymentInformation: [],
  selected_paymentInformation: '',
  is_loading_paymentInformation: false,
  is_creating_paymentInformation: false,
  is_deleting_paymentInformation: false,
}
export interface paymentInformationSliceState {
  paymentInformation: PaymentInformation[]
  selected_paymentInformation?: string
  is_loading_paymentInformation: boolean
  is_creating_paymentInformation: boolean
  is_deleting_paymentInformation: boolean
}
export const paymentInformationSlice = createSlice({
  name: 'paymentInformation',
  initialState,
  reducers: {
    setSelectedpaymentInformation: (state, action) => {
      state.selected_paymentInformation = action.payload
    },
    clearStatepaymentInformation: (state) => {
      state.paymentInformation = []
      state.is_loading_paymentInformation = false
      state.is_creating_paymentInformation = false
      state.is_deleting_paymentInformation = false
    },
    mergepaymentInformation: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_paymentInformation = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.paymentInformation = merge(
            state.paymentInformation,
            payload,
          ) as any
        }
      }
    },

    add_paymentInformation: (state, action) => {
      if (action.payload) {
        state.paymentInformation = [...state.paymentInformation, action.payload]
      }
    },
    set_paymentInformation: (state, action) => {
      let { key, value, id } = action.payload
      state.paymentInformation = state.paymentInformation.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadPaymentInformationsAsync.pending, (state) => {
      state.is_loading_paymentInformation = true
    })
    builder.addCase(LoadPaymentInformationsAsync.fulfilled, (state, action) => {
      state.is_loading_paymentInformation = false
      if (action.payload) {
        state.paymentInformation = action.payload
      }
    })
    builder.addCase(LoadPaymentInformationsAsync.rejected, (state) => {
      state.is_loading_paymentInformation = false
    })
    builder.addCase(CreatePaymentInformationAsync.pending, (state) => {
      state.is_creating_paymentInformation = true
    })
    builder.addCase(CreatePaymentInformationAsync.fulfilled, (state) => {
      state.is_creating_paymentInformation = false
    })
    builder.addCase(CreatePaymentInformationAsync.rejected, (state) => {
      state.is_creating_paymentInformation = false
    })
    builder.addCase(DeletePaymentInformationAsync.pending, (state) => {
      state.is_deleting_paymentInformation = true
    })
    builder.addCase(
      DeletePaymentInformationAsync.fulfilled,
      (state, action) => {
        state.is_deleting_paymentInformation = false
        if (state.paymentInformation) {
          state.paymentInformation = state.paymentInformation.filter(
            (x) => action.payload.id !== x.id,
          )
        }
      },
    )
    builder.addCase(DeletePaymentInformationAsync.rejected, (state) => {
      state.is_deleting_paymentInformation = false
    })
  },
})

export const {
  clearStatepaymentInformation,
  setSelectedpaymentInformation,
  set_paymentInformation,
  mergepaymentInformation,
  add_paymentInformation,
} = paymentInformationSlice.actions

export const get_paymentInformation =
  (id?: string) =>
  (state: {
    paymentInformation: {
      paymentInformation: PaymentInformation[]
    }
  }): PaymentInformation | null => {
    let temp = state?.paymentInformation?.paymentInformation?.find(
      (v) => v.id === id,
    )
    if (temp) {
      return temp
    }
    return state?.paymentInformation?.paymentInformation[0] || null
  }
export const get_selected_paymentInformation = (state: {
  paymentInformation: paymentInformationSliceState
}): PaymentInformation | null => {
  let id = state?.paymentInformation?.selected_paymentInformation
  let temp = state?.paymentInformation?.paymentInformation?.find(
    (v) => v.id === id,
  )
  if (temp) {
    return temp
  }
  return null
}
export const get_all_paymentInformation = (state: {
  paymentInformation: {
    paymentInformation: PaymentInformation[]
  }
}): PaymentInformation[] => {
  let temp = state?.paymentInformation?.paymentInformation
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_paymentInformation_busy = (state: {
  paymentInformation: paymentInformationSliceState
}) => {
  return (
    state?.paymentInformation.is_deleting_paymentInformation ||
    state?.paymentInformation.is_loading_paymentInformation ||
    state?.paymentInformation.is_creating_paymentInformation
  )
}
export const is_deleting_paymentInformation_busy = (state: {
  paymentInformation: paymentInformationSliceState
}) => {
  return state?.paymentInformation.is_deleting_paymentInformation
}
export const is_loading_paymentInformation_busy = (state: {
  paymentInformation: paymentInformationSliceState
}) => {
  return state?.paymentInformation.is_loading_paymentInformation
}
export const is_creating_paymentInformation_busy = (state: {
  paymentInformation: paymentInformationSliceState
}) => {
  return state?.paymentInformation.is_creating_paymentInformation
}

export default paymentInformationSlice.reducer
